/**
 * @generated SignedSource<<41d50d5817f0bec08814bbe5c2e9e397>>
 * @relayHash 6bf94d0c616c7c526d439f229b5d7955
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6bf94d0c616c7c526d439f229b5d7955

import type { ConcreteRequest } from 'relay-runtime';
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type IssueStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "REOPENED" | "%future added value";
export type SearchType = "DISCUSSION" | "ISSUE" | "ISSUE_ADVANCED" | "ISSUE_HYBRID" | "ISSUE_SEMANTIC" | "REPOSITORY" | "USER" | "USER_LOGIN" | "%future added value";
export type useIssueFilteringQuery$variables = {
  assignee: string;
  author: string;
  commenters: string;
  first?: number | null | undefined;
  includeSemanticallySimilar?: boolean | null | undefined;
  mentions: string;
  other: string;
  queryIsUrl: boolean;
  requireTargetTriage?: boolean | null | undefined;
  resource: string;
  semanticSearchType?: SearchType | null | undefined;
  semanticallySimilarQuery?: string | null | undefined;
  withParent: boolean;
};
export type useIssueFilteringQuery$data = {
  readonly assignee: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "Issue";
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly number: number;
      readonly parent?: {
        readonly id: string;
      } | null | undefined;
      readonly repository: {
        readonly id: string;
        readonly nameWithOwner: string;
      };
      readonly state: IssueState;
      readonly stateReason: IssueStateReason | null | undefined;
      readonly title: string;
      readonly url: string;
      readonly viewerCanUpdateMetadata?: boolean | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
  readonly author: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "Issue";
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly number: number;
      readonly parent?: {
        readonly id: string;
      } | null | undefined;
      readonly repository: {
        readonly id: string;
        readonly nameWithOwner: string;
      };
      readonly state: IssueState;
      readonly stateReason: IssueStateReason | null | undefined;
      readonly title: string;
      readonly url: string;
      readonly viewerCanUpdateMetadata?: boolean | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
  readonly commenters: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "Issue";
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly number: number;
      readonly parent?: {
        readonly id: string;
      } | null | undefined;
      readonly repository: {
        readonly id: string;
        readonly nameWithOwner: string;
      };
      readonly state: IssueState;
      readonly stateReason: IssueStateReason | null | undefined;
      readonly title: string;
      readonly url: string;
      readonly viewerCanUpdateMetadata?: boolean | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
  readonly mentions: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "Issue";
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly number: number;
      readonly parent?: {
        readonly id: string;
      } | null | undefined;
      readonly repository: {
        readonly id: string;
        readonly nameWithOwner: string;
      };
      readonly state: IssueState;
      readonly stateReason: IssueStateReason | null | undefined;
      readonly title: string;
      readonly url: string;
      readonly viewerCanUpdateMetadata?: boolean | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
  readonly other: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "Issue";
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly number: number;
      readonly parent?: {
        readonly id: string;
      } | null | undefined;
      readonly repository: {
        readonly id: string;
        readonly nameWithOwner: string;
      };
      readonly state: IssueState;
      readonly stateReason: IssueStateReason | null | undefined;
      readonly title: string;
      readonly url: string;
      readonly viewerCanUpdateMetadata?: boolean | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
  readonly resource?: {
    readonly __typename: "Issue";
    readonly databaseId: number | null | undefined;
    readonly id: string;
    readonly number: number;
    readonly parent?: {
      readonly id: string;
    } | null | undefined;
    readonly repository: {
      readonly id: string;
      readonly nameWithOwner: string;
    };
    readonly state: IssueState;
    readonly stateReason: IssueStateReason | null | undefined;
    readonly title: string;
    readonly url: string;
    readonly viewerCanUpdateMetadata?: boolean | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly semanticallySimilar?: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "Issue";
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly number: number;
      readonly parent?: {
        readonly id: string;
      } | null | undefined;
      readonly repository: {
        readonly id: string;
        readonly nameWithOwner: string;
      };
      readonly state: IssueState;
      readonly stateReason: IssueStateReason | null | undefined;
      readonly title: string;
      readonly url: string;
      readonly viewerCanUpdateMetadata?: boolean | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
};
export type useIssueFilteringQuery = {
  response: useIssueFilteringQuery$data;
  variables: useIssueFilteringQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assignee"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "author"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commenters"
},
v3 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSemanticallySimilar"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mentions"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "other"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryIsUrl"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "requireTargetTriage"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resource"
},
v10 = {
  "defaultValue": "ISSUE_ADVANCED",
  "kind": "LocalArgument",
  "name": "semanticSearchType"
},
v11 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "semanticallySimilarQuery"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withParent"
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "semanticallySimilarQuery"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "semanticSearchType"
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v22 = {
  "condition": "requireTargetTriage",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanUpdateMetadata",
      "storageKey": null
    }
  ]
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v24 = [
  (v14/*: any*/)
],
v25 = {
  "condition": "withParent",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Issue",
      "kind": "LinkedField",
      "name": "parent",
      "plural": false,
      "selections": (v24/*: any*/),
      "storageKey": null
    }
  ]
},
v26 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v25/*: any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  }
],
v27 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": (v26/*: any*/),
    "storageKey": null
  }
],
v28 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v29 = {
  "kind": "Literal",
  "name": "type",
  "value": "ISSUE"
},
v30 = [
  (v28/*: any*/),
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "commenters"
  },
  (v29/*: any*/)
],
v31 = [
  (v28/*: any*/),
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "mentions"
  },
  (v29/*: any*/)
],
v32 = [
  (v28/*: any*/),
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "assignee"
  },
  (v29/*: any*/)
],
v33 = [
  (v28/*: any*/),
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "author"
  },
  (v29/*: any*/)
],
v34 = [
  (v28/*: any*/),
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "other"
  },
  (v29/*: any*/)
],
v35 = [
  {
    "kind": "Variable",
    "name": "url",
    "variableName": "resource"
  }
],
v36 = [
  (v23/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v25/*: any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v24/*: any*/),
    "type": "Node",
    "abstractKey": "__isNode"
  }
],
v37 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": (v36/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useIssueFilteringQuery",
    "selections": [
      {
        "condition": "includeSemanticallySimilar",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "semanticallySimilar",
            "args": (v13/*: any*/),
            "concreteType": "SearchResultItemConnection",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": (v27/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "alias": "commenters",
        "args": (v30/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v27/*: any*/),
        "storageKey": null
      },
      {
        "alias": "mentions",
        "args": (v31/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v27/*: any*/),
        "storageKey": null
      },
      {
        "alias": "assignee",
        "args": (v32/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v27/*: any*/),
        "storageKey": null
      },
      {
        "alias": "author",
        "args": (v33/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v27/*: any*/),
        "storageKey": null
      },
      {
        "alias": "other",
        "args": (v34/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v27/*: any*/),
        "storageKey": null
      },
      {
        "condition": "queryIsUrl",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v35/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "resource",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v12/*: any*/),
      (v8/*: any*/),
      (v11/*: any*/),
      (v4/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Operation",
    "name": "useIssueFilteringQuery",
    "selections": [
      {
        "alias": "commenters",
        "args": (v30/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v37/*: any*/),
        "storageKey": null
      },
      {
        "alias": "mentions",
        "args": (v31/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v37/*: any*/),
        "storageKey": null
      },
      {
        "alias": "assignee",
        "args": (v32/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v37/*: any*/),
        "storageKey": null
      },
      {
        "alias": "author",
        "args": (v33/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v37/*: any*/),
        "storageKey": null
      },
      {
        "alias": "other",
        "args": (v34/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v37/*: any*/),
        "storageKey": null
      },
      {
        "condition": "includeSemanticallySimilar",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "semanticallySimilar",
            "args": (v13/*: any*/),
            "concreteType": "SearchResultItemConnection",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": (v37/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "queryIsUrl",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v35/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "resource",
            "plural": false,
            "selections": (v36/*: any*/),
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6bf94d0c616c7c526d439f229b5d7955",
    "metadata": {},
    "name": "useIssueFilteringQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "859d1dc64e2bdde8b88a2ef914057944";

export default node;
